module.exports = __webpack_public_path__ + "static/media/body-bg-bottom.c777e407.jpg";